export enum DeliveryFilterEnum {
  RouteName = 'RouteName',
  Total = 'Total',
}
